module.exports = angular.module('ui-ng-pie', []).directive('phxPie', function () {
  var COMPONENT = 'ui-ng-pie';
  var PI = 3.14159;
  var BRAND_COLOR_REGEX = /^(\$*)brand-color--/;
  var makeSVG = function makeSVG(tag, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (var k in attrs) {
      el.setAttribute(k, attrs[k]);
    }
    return el;
  };

  return {
    restrict: 'E',
    scope: {
      diameter: '@',
      values: '=',
      colors: '=',
      isRadial: '<?'
    },
    template: '<svg class="phx-chart-pie"></svg>',
    compile: function (element, attrs) {
      element.addClass('phx-chart-pie');
      return function (scope, element, attrs) {
        var size = Number(scope.diameter);
        var valuesList = scope.values;
        var isRadial = !!scope.isRadial;
        // these are now straight colors and not color names
        //
        var colorsList = scope.colors;

        if (!Array.isArray(valuesList) || !Array.isArray(colorsList)) {
          throw new EABError(COMPONENT, 100);
        }

        if (isNaN(size) || typeof size !== 'number') {
          throw new EABError(COMPONENT, 101);
        }

        if (valuesList.length > colorsList.length) {
          throw new EABError(COMPONENT, 102);
        }

        // we do not need to re-write the color list, it already has colors and not color names
        //
        // _.each(colorsList, function (color, i) {
        //   if (BRAND_COLOR_REGEX.test(color)) {
        //     if (!Brand.color[color]) {
        //       throw new EABError(COMPONENT, 103);
        //     }
        //     this[i] = Brand.color[color];
        //   }
        // }, colorsList);

        var radius = size / 4;
        var circleX = size / 2;
        var circleY = size / 2;

        var circumference = 2 * PI * radius;
        var total = _.reduce(valuesList, _.add);

        var percentages = _.map(
          valuesList,
          function (n, i) {
            return {
              percent: n / this,
              accumulated:
                n / this +
                (i > 0
                  ? _.reduce(
                      _.map(
                        valuesList.slice(0, i),
                        function (val) {
                          return val / this;
                        },
                        total
                      ),
                      _.add
                    )
                  : 0)
            };
          },
          total
        );

        var svg = element.children();

        _.first(svg).setAttributeNS(null, 'height', size);
        _.first(svg).setAttributeNS(null, 'width', size);

        _.times(percentages.length - 1, function (n) {
          svg.append(
            makeSVG('circle', {
              cx: circleX,
              cy: circleY,
              r: radius
            })
          );
        });

        var circles = element.children().children();

        _.each(percentages, function (val, i) {
          if (i > 0) {
            circles
              .eq(percentages.length - 1 - i)
              .css('stroke', colorsList[i - 1])
              .css('stroke-width', radius * 2)
              .css('stroke-dasharray', percentages[i - 1].accumulated * circumference + ' ' + circumference);
          }
        });

        circles.css('fill', 'none');

        if (isRadial) {
          svg.append(
            makeSVG('circle', {
              cx: circleX,
              cy: circleY,
              r: radius * 1.6,
              fill: 'white'
            })
          );
        }

        element.children().css('background', colorsList[percentages.length - 1]);
      };
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-pie/src/core.js